import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { BASE_URL } from '../../utils/axios';
import { buildUrlParams } from '../../utils/urls';
import { parsePaginatedResponse } from '../../utils/pagination';

export const audiencesApi = createApi({
  reducerPath: 'audiencesApi',
  tagTypes: ['Audiences'],
  keepUnusedDataFor: 600,
  endpoints: (builder) => ({
    getAudiencesForProject: builder.query({
      async queryFn(arg) {
        try {
          const url = `/api/v1/audiences/${buildUrlParams(arg)}`;
          const { data } = await axios.get(BASE_URL + url);
          return { data: parsePaginatedResponse({ data }) };
        } catch (e) {
          return {
            error: {
              status: e.response?.status,
              data: e.response?.data ?? e.message,
            },
          };
        }
      },
      providesTags: (_result, _err, arg) =>
        arg?.project_hash ? [{ type: 'Audiences', id: arg.project_hash }] : [],
    }),
    deleteAudience: builder.mutation({
      async queryFn({ hash }) {
        try {
          await axios.delete(`${BASE_URL}/api/v1/audiences/${hash}/`);
          return { data: { hash } };
        } catch (e) {
          return {
            error: {
              status: e.response?.status,
              data: e.response?.data ?? e.message,
            },
          };
        }
      },
      async onQueryStarted({ hash }, { dispatch, getState, queryFulfilled }) {
        const patches = audiencesApi.util
          .selectCachedArgsForQuery(getState(), 'getAudiencesForProject')
          .map((args) =>
            dispatch(
              audiencesApi.util.updateQueryData('getAudiencesForProject', args, (draft) => {
                if (!draft?.results) return;
                const next = draft.results.filter((row) => row.hash !== hash);
                if (next.length === draft.results.length) return;
                draft.results = next;
                if (typeof draft.count === 'number') {
                  draft.count = Math.max(0, draft.count - 1);
                }
              })
            )
          );
        try {
          await queryFulfilled;
        } catch {
          patches.forEach((p) => p.undo());
        }
      },
    }),
  }),
});

export const { useGetAudiencesForProjectQuery, useDeleteAudienceMutation } = audiencesApi;
